/* Krishna Furniture — contact page behaviour (reveals, tilt, 3D stage). */

/* ============================================================
   Contact hero — "Pull up a chair", rendered rather than drawn.

   Deliberately the SAME chair, materials and lighting model as the About page's
   manufacturing sequence: About shows how the piece is made, Contact shows two of
   them waiting for you. Sharing the model is what makes the two pages read as one
   brand rather than two templates.
   ============================================================ */
(function(){
  var canvas=document.getElementById('chairscv');
  if(!canvas || typeof THREE==='undefined') return;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var renderer,scene,camera,group,raf=null,visible=false;
  var mouseX=0,mouseY=0,curX=0,curY=0,t0=performance.now();

  function canvasTex(w,h,draw,repeat){
    var c=document.createElement('canvas'); c.width=w; c.height=h;
    draw(c.getContext('2d'),w,h);
    var t=new THREE.CanvasTexture(c);
    t.wrapS=t.wrapT=THREE.RepeatWrapping;
    if(repeat) t.repeat.set(repeat[0],repeat[1]);
    return t;
  }

  function roundedBox(w,h,d,r){
    var s=new THREE.Shape(), x=-w/2, y=-h/2;
    r=Math.min(r,w/2-0.001,h/2-0.001);
    s.moveTo(x+r,y);
    s.lineTo(x+w-r,y); s.quadraticCurveTo(x+w,y,x+w,y+r);
    s.lineTo(x+w,y+h-r); s.quadraticCurveTo(x+w,y+h,x+w-r,y+h);
    s.lineTo(x+r,y+h); s.quadraticCurveTo(x,y+h,x,y+h-r);
    s.lineTo(x,y+r); s.quadraticCurveTo(x,y,x+r,y);
    var b=Math.min(r*0.8,d*0.32);
    var g=new THREE.ExtrudeGeometry(s,{depth:Math.max(0.01,d-b*2),bevelEnabled:true,
      bevelThickness:b,bevelSize:b,bevelSegments:3,curveSegments:12});
    g.center(); g.computeVertexNormals();
    return g;
  }

  function init(){
    renderer=new THREE.WebGLRenderer({canvas:canvas,antialias:true,alpha:true});
    renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,2));
    renderer.outputEncoding=THREE.sRGBEncoding;
    renderer.toneMapping=THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure=1.0;
    renderer.shadowMap.enabled=true;
    renderer.shadowMap.type=THREE.PCFSoftShadowMap;

    scene=new THREE.Scene();
    camera=new THREE.PerspectiveCamera(28,1.75,0.1,60);

    var woodMap=canvasTex(512,512,function(x,w,h){
      x.fillStyle='#6f4726'; x.fillRect(0,0,w,h);
      for(var i=0;i<240;i++){
        var y=Math.random()*h, amp=3+Math.random()*8, freq=.6+Math.random()*1.6;
        x.strokeStyle=(Math.random()<.5?'rgba(48,28,14,':'rgba(158,112,66,')+(0.03+Math.random()*0.08)+')';
        x.lineWidth=0.5+Math.random()*2.2; x.beginPath();
        for(var px=0;px<=w;px+=12){
          var yy=y+Math.sin(px/w*Math.PI*2*freq)*amp+Math.sin(px*0.05)*2;
          px===0?x.moveTo(px,yy):x.lineTo(px,yy);
        }
        x.stroke();
      }
    },[2,1]);
    woodMap.encoding=THREE.sRGBEncoding;

    var linenMap=canvasTex(256,256,function(x,w,h){
      x.fillStyle='#d7c9b2'; x.fillRect(0,0,w,h);
      for(var i=0;i<w;i+=4){
        x.fillStyle='rgba(255,252,244,.30)'; x.fillRect(i,0,1.8,h);
        x.fillStyle='rgba(120,104,80,.13)'; x.fillRect(i+2,0,1.2,h);
      }
      for(var j=0;j<h;j+=4){
        x.fillStyle='rgba(255,252,244,.22)'; x.fillRect(0,j,w,1.8);
        x.fillStyle='rgba(120,104,80,.15)'; x.fillRect(0,j+2,w,1.2);
      }
    },[3,3]);
    linenMap.encoding=THREE.sRGBEncoding;

    // Same little studio-in-a-texture as the About page, tuned brighter because this
    // hero sits on paper rather than espresso.
    var envTex=canvasTex(128,64,function(x,w,h){
      var g=x.createLinearGradient(0,0,0,h);
      g.addColorStop(0,'#fffaf0'); g.addColorStop(.40,'#eaddc6');
      g.addColorStop(.58,'#a8977f'); g.addColorStop(1,'#4a3d30');
      x.fillStyle=g; x.fillRect(0,0,w,h);
      x.fillStyle='rgba(255,250,238,.95)';
      x.beginPath(); x.ellipse(w*0.32,h*0.18,w*0.11,h*0.14,0,0,Math.PI*2); x.fill();
    });
    envTex.mapping=THREE.EquirectangularReflectionMapping;
    var pmrem=new THREE.PMREMGenerator(renderer);
    scene.environment=pmrem.fromEquirectangular(envTex).texture;
    pmrem.dispose();

    var walnut=new THREE.MeshStandardMaterial({map:woodMap,color:0xbcaa96,roughness:.66,metalness:.02,envMapIntensity:.5});
    var linen =new THREE.MeshStandardMaterial({map:linenMap,color:0xd6c9b1,roughness:.95,metalness:0,envMapIntensity:.45});
    var brass =new THREE.MeshStandardMaterial({color:0xa07a34,roughness:.30,metalness:.95,envMapIntensity:.9});

    function mesh(geo,mat,x,y,z){
      var m=new THREE.Mesh(geo,mat); m.position.set(x||0,y||0,z||0);
      m.castShadow=true; m.receiveShadow=true; return m;
    }

    /* One chair, built once and cloned — the same silhouette the About page assembles. */
    function makeChair(){
      var g=new THREE.Group();
      var SEAT_H=.46, ARM_H=1.00, RAKE=-.17;
      [[-.86,.66],[.86,.66],[-.80,-.62],[.80,-.62]].forEach(function(p){
        var front=p[1]>0;
        var leg=mesh(new THREE.CylinderGeometry(.082,.042,SEAT_H,14),walnut,p[0],SEAT_H/2,p[1]);
        leg.rotation.x=(front?1:-1)*.10; leg.rotation.z=(p[0]>0?-1:1)*.09; g.add(leg);
        var f=mesh(new THREE.CylinderGeometry(.046,.044,.04,14),brass,p[0],.021,p[1]);
        f.rotation.copy(leg.rotation); g.add(f);
      });
      g.add(mesh(roundedBox(1.94,.14,1.62,.05),walnut,0,SEAT_H+.06,0));
      [-1,1].forEach(function(sx){
        var post=mesh(roundedBox(.11,.92,.12,.045),walnut,sx*.90,1.06,-.62); post.rotation.x=RAKE; g.add(post);
        g.add(mesh(roundedBox(.10,.34,.10,.04),walnut,sx*.90,SEAT_H+.30,.52));
        g.add(mesh(roundedBox(.23,.10,1.46,.045),walnut,sx*.90,ARM_H,-.02));
        g.add(mesh(roundedBox(.21,.11,1.34,.048),linen,sx*.90,ARM_H+.075,-.02));
      });
      var rail=mesh(roundedBox(1.92,.13,.14,.06),walnut,0,1.52,-.76); rail.rotation.x=RAKE; g.add(rail);
      g.add(mesh(roundedBox(1.80,.30,1.52,.14),linen,0,.72,.02));
      var back=mesh(roundedBox(1.68,.78,.28,.14),linen,0,1.06,-.60); back.rotation.x=RAKE; g.add(back);
      for(var t=-3;t<=3;t++) g.add(mesh(new THREE.SphereGeometry(.030,8,6),brass,t*.25,SEAT_H+.06,.80));
      return g;
    }

    group=new THREE.Group();

    // Turned slightly in toward each other — the whole point of the page is a conversation.
    var left=makeChair();  left.position.set(-1.58,0,.12);  left.rotation.y= .58; group.add(left);
    var right=makeChair(); right.position.set( 1.58,0,.12); right.rotation.y=-.58; group.add(right);

    // Brass pedestal table between them
    var table=new THREE.Group();
    table.add(mesh(new THREE.CylinderGeometry(.46,.46,.055,36),brass,0,.70,0));
    table.add(mesh(new THREE.CylinderGeometry(.055,.055,.68,20),brass,0,.35,0));
    table.add(mesh(new THREE.CylinderGeometry(.30,.34,.05,28),brass,0,.025,0));
    table.position.z=.10; group.add(table);

    group.position.y=-.62;
    scene.add(group);

    var floor=new THREE.Mesh(new THREE.PlaneGeometry(30,30),new THREE.ShadowMaterial({opacity:.16}));
    floor.rotation.x=-Math.PI/2; floor.position.y=-.63; floor.receiveShadow=true; scene.add(floor);

    scene.add(new THREE.HemisphereLight(0xfffaf0,0x6b5a48,.75));
    var key=new THREE.DirectionalLight(0xfff3e2,1.55);
    key.position.set(3.6,6.6,5.2); key.castShadow=true;
    key.shadow.mapSize.set(1024,1024);
    key.shadow.camera.near=1; key.shadow.camera.far=24;
    key.shadow.camera.left=-8; key.shadow.camera.right=8;
    key.shadow.camera.top=6; key.shadow.camera.bottom=-6;
    key.shadow.bias=-0.0012; key.shadow.radius=3;
    scene.add(key);
    var fill=new THREE.DirectionalLight(0xd8e4f2,.34); fill.position.set(-6,2.6,3); scene.add(fill);
    var rim=new THREE.DirectionalLight(0xffd9a0,.5); rim.position.set(-1.5,3,-6); scene.add(rim);

    resize();
  }

  function resize(){
    if(!renderer) return;
    var w=canvas.clientWidth||520, h=canvas.clientHeight||300;
    renderer.setSize(w,h,false);
    camera.aspect=w/h; camera.updateProjectionMatrix();
  }

  function frame(){
    raf=requestAnimationFrame(frame);
    if(!visible) return;
    // A slow breathing drift plus a little parallax: enough to feel alive and
    // inviting, never enough to distract from the copy beside it.
    var t=(performance.now()-t0)/1000;
    curX+=(mouseX-curX)*.06; curY+=(mouseY-curY)*.06;
    var yaw=(reduce?0:Math.sin(t*.18)*.055)+curX*.30;
    var pitch=1.40-(reduce?0:Math.sin(t*.24)*.016)-curY*.11;
    var r=6.95;
    camera.position.set(r*Math.sin(pitch)*Math.sin(yaw), r*Math.cos(pitch)+.30, r*Math.sin(pitch)*Math.cos(yaw));
    camera.lookAt(0,.16,0);
    renderer.render(scene,camera);
  }

  try{ init(); }catch(e){ canvas.style.display='none'; return; }

  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){ visible=es[0].isIntersecting; }).observe(canvas);
  } else visible=true;

  window.addEventListener('resize',resize);
  var hero=document.querySelector('.hero');
  if(hero && !window.matchMedia('(hover: none)').matches){
    hero.addEventListener('mousemove',function(e){
      var r=hero.getBoundingClientRect();
      mouseX=(e.clientX-r.left)/r.width-.5;
      mouseY=(e.clientY-r.top)/r.height-.5;
    });
    hero.addEventListener('mouseleave',function(){ mouseX=0; mouseY=0; });
  }
  frame();
})();


(function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch=window.matchMedia('(hover: none)').matches;

  /* reveal */
  var els=document.querySelectorAll('.rv,.stg');
  if(!('IntersectionObserver' in window)||reduce){els.forEach(function(e){e.classList.add('in');});}
  else{var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.14,rootMargin:'0px 0px -6% 0px'});els.forEach(function(e){io.observe(e);});}

  /* tilt on channel cards + hero chairs */
  if(!touch&&!reduce){
    document.querySelectorAll('[data-tilt]').forEach(function(c){
      c.addEventListener('mousemove',function(e){var r=c.getBoundingClientRect();var px=(e.clientX-r.left)/r.width-.5,py=(e.clientY-r.top)/r.height-.5;c.style.transform='rotateY('+(px*8)+'deg) rotateX('+(-py*8)+'deg) translateY(-4px)';c.style.boxShadow='0 20px 44px rgba(34,26,19,.12)';});
      c.addEventListener('mouseleave',function(){c.style.transform='';c.style.boxShadow='';});
    });
    var hero=document.querySelector('.hero'),ch=document.querySelector('.chairs');
    if(hero&&ch){hero.addEventListener('mousemove',function(e){var r=hero.getBoundingClientRect();var px=(e.clientX-r.left)/r.width-.5,py=(e.clientY-r.top)/r.height-.5;ch.style.transform='perspective(1200px) rotateY('+(px*5)+'deg) rotateX('+(-py*5)+'deg)';ch.style.transition='transform .2s var(--ease)';});hero.addEventListener('mouseleave',function(){ch.style.transform='';});}
  }

  /* showroom cards <-> map nodes + directions */
  document.querySelectorAll('#list .show').forEach(function(card){
    var i=card.getAttribute('data-node');var node=document.getElementById('node-'+i);
    function hot(on){if(!node)return;node.setAttribute('r',on?9:5);node.style.fill=on?'#a9823f':'';node.style.filter=on?'drop-shadow(0 0 6px rgba(201,165,106,.8))':'';}
    card.addEventListener('mouseenter',function(){hot(true);});
    card.addEventListener('mouseleave',function(){hot(false);});
    card.addEventListener('click',function(){var q=encodeURIComponent(card.getAttribute('data-q'));window.open('https://www.google.com/maps/search/?api=1&query='+q,'_blank');});
  });

  /* form -> WhatsApp compose (replace the number with your real WhatsApp) */
  /* The number is written onto the send button by the section, so changing it in
     Customize changes it everywhere — it used to be hard-coded here as well as in
     three places in the markup, which is three places to forget. */
  var sendBtn=document.getElementById('send');
  var NUMBER=(sendBtn && sendBtn.getAttribute('data-wa')) || '919319574949';
  function v(id){var el=document.getElementById(id);return el?el.value.trim():'';}
  var btn=document.getElementById('send');
  if(btn)btn.addEventListener('click',function(){
    var lines=['Hello Krishna Furniture,','',
      'Name: '+(v('nm')||'—'),
      'Phone: '+(v('ph')||'—'),
      'Email: '+(v('em')||'—'),
      'Looking for: '+v('wt'),
      'Preferred showroom: '+v('sr'),
      '', (v('msg')||'(no message)')];
    var url='https://wa.me/'+NUMBER+'?text='+encodeURIComponent(lines.join('\n'));
    window.open(url,'_blank');
  });
})();

/* Showroom picker -> Google map. The rows already carry data-q (search query) and
   data-page. Swapping on click rather than hover keeps it to one iframe load per
   choice; hovering only lifts the card, which the CSS already does. */
(function(){
  var frame=document.getElementById('kfmap');
  var where=document.getElementById('kfmapwhere');
  var open=document.getElementById('kfmapopen');
  var rows=[].slice.call(document.querySelectorAll('.show[data-q]'));
  if(!frame||!rows.length) return;
  function select(row){
    var q=row.getAttribute('data-q'); if(!q) return;
    var city=(row.querySelector('.city')||{}).textContent||'';
    var area=(row.querySelector('.area')||{}).textContent||'';
    frame.src='https://www.google.com/maps?q='+encodeURIComponent(q)+'&output=embed';
    if(where) where.textContent=(city+' · '+area).replace(/\s+/g,' ').trim();
    if(open) open.href='https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(q);
    rows.forEach(function(r){ r.classList.toggle('is-active', r===row); r.setAttribute('aria-pressed', r===row?'true':'false'); });
  }
  rows.forEach(function(row,i){
    row.setAttribute('tabindex','0');
    row.setAttribute('role','button');
    row.setAttribute('aria-pressed', i===0?'true':'false');
    if(i===0) row.classList.add('is-active');
    row.addEventListener('click',function(e){ if(e.target.closest('a')) return; select(row); });
    row.addEventListener('keydown',function(e){
      if(e.key==='Enter'||e.key===' '){ e.preventDefault(); select(row); }
    });
  });
})();
